import { AxiosError, AxiosResponse } from 'axios';
import useSWR, { mutate } from 'swr';

import { ApiPortfolio } from '../models/ApiPortfolio';
import Config from '../../shared/config';

export function useLatestPortfolioModules(
  userkey: number,
  coursekey: number,
  version: number
) {
  const url =
    userkey && coursekey && version
      ? `${Config.API}/api/portfolio/list/portfolio/user/${userkey}/course/${coursekey}/version/${version}`
      : null;

  const {
    isLoading,
    data: response,
    error
  } = useSWR<AxiosResponse<ApiPortfolio[]>, AxiosError<Error>>(url);

  const updatePortfolios = async () => {
    await mutate(url);
  };

  return {
    loadingLatestPortfolios: isLoading,
    latestPortfoliosError: error,
    latestPortfolios: response?.data || [],
    updatePortfolios
  };
}
